import UrgentModal from "@/components/common/Modal/UrgentModal";

import { Box, useDisclosure } from "@chakra-ui/react";
import { Button, ColorIcon, colors, customEvent, HStack, VStack } from "goi_common";
import MatchCompareDetailRequest from "./components/MatchRequest/MatchCompareDetailRequest";

export default function MatchCompareDetailRequestContainer() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <VStack alignItems="center">
      <VStack id="wrapper" width="100%" maxWidth="480px">
        <UrgentModal onClose={onClose} isOpen={isOpen} />
        <VStack gap="10px" padding="18px 4px 8px 24px">
          <HStack alignItems="center" justifyContent="space-between">
            <Box className="subtitle_21_b black">
              장례 비용 알아보기
              <br />
              (상세 견적)
            </Box>

            <VStack gap={10}>
              <Button
                style={{
                  borderRadius: 16,
                  backgroundColor: colors.orange100,
                  padding: "6px 14px",
                  boxShadow: "2px 2px 2px #00000022",
                }}
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "match_request",
                      trigger_and_target: "quick_cnslt-opn_urgnt_mdl",
                    },
                  });
                  onOpen();
                }}
              >
                <HStack alignItems="center" gap={10}>
                  <ColorIcon
                    name="icon-call-mono"
                    color={colors.orange650}
                    width={12}
                    height={12}
                  />
                  <div className="caption_12_sb orange700">빠른 상담</div>{" "}
                  <ColorIcon name="icon-arrow-right-small-mono" color={colors.orange700} size={8} />
                </HStack>
              </Button>
            </VStack>
          </HStack>
        </VStack>

        {/* <MatchRequestStepper step={2} /> */}
        <MatchCompareDetailRequest />
      </VStack>
    </VStack>
  );
}
